module.exports = __webpack_public_path__ + "img/lock.11fc13e5.svg";